import api from './api';
// 获得新闻列表
export function jobList(params) {
  return api.post('/en/join/getJobList', params, true, false);
}



// WEBPACK FOOTER //
// ./src/api/enFrontApi/join.js